import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-nav" }
const _hoisted_2 = { class: "admin-nav-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "어신 백오피스", -1)
const _hoisted_4 = { class: "admin-menu" }
const _hoisted_5 = { class: "menu-list" }
const _hoisted_6 = /*#__PURE__*/_createVNode("li", { class: "nav-header" }, "커머스 관리", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-building fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 셀러 관리 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-database fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 상품 카테고리 관리 ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fa-brands fa-product-hunt fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 상품 관리 ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fa-brands fa-product-hunt fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 상품 프로모션 관리 ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fa-brands fa-product-hunt fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 주문 관리 ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("li", { class: "nav-header" }, "발주관리", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fa-brands fa-product-hunt fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 미발주내역 ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "fa-brands fa-product-hunt fa-xl" })
  ]),
  /*#__PURE__*/_createTextVNode(" 발주내역 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "admin-nav-link"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("ul", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_router_link, {
          to: "/commerce/seller",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/commerce/product-category",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/commerce/product",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/commerce/promotion",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/commerce/order",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _hoisted_12,
        _createVNode(_component_router_link, {
          to: "/commerce/contract",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/commerce/placing-order-after",
          class: "admin-nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ])
  ]))
}